export const mutations = {
  PUSH_NOTIFICATION(state, notification) {
    state.notifications.push({
      ...notification,
      id: (Math.random().toString(36) + Date.now().toString(36)).substr(2)
    });
  },
  REMOVE_NOTIFICATION(state, notification) {
    state.notifications.splice(state.notifications.indexOf(notification));
  },

  //acls
  SET_MY_ACLS(state, acls) {
    state.myacls = acls.auth_users;
  },
  SET_ACLS(state, acls) {
    state.acls = acls.auth_users;
  },
  SET_RECORDS_I_AM_AUTHORIZED_ON(state, recordsiamauthorizedon) {
    state.recordsiamauthorizedon = recordsiamauthorizedon;
  },
  SET_RECORDS_OF_SELECTED_ACCOUNT_IS_AUTHORIZED_ON(
    state,
    accountsauthorizedon
  ) {
    state.accountsauthorizedon = accountsauthorizedon;
  }
};
